const companyLogo: string = process.env.REACT_APP_DELIEVERY_NOTE_LOGO || './';
const companyName: string = process.env.REACT_APP_DELIEVERY_NOTE_NAME || '-';
const companyStreet: string = process.env.REACT_APP_DELIEVERY_NOTE_STREET || '-';
const companyPostalCode: string = process.env.REACT_APP_DELIEVERY_NOTE_POSTALCODE || '-';
const companyTown: string = process.env.REACT_APP_DELIEVERY_NOTE_TOWN || '-';
const showItemDescription: boolean = process.env.REACT_APP_DELIEVERY_NOTE_DESCRIPTION === 'true';

const LagerEntnahmeSchein = ({
    street,
    housenumber,
    postalcode,
    town,
    manager,
    object_id,
    object_number,
    created,
    order_id,
    comment,
    object_note,
    company,
    products,
}: {
    street?: string;
    housenumber?: string;
    postalcode?: string;
    object_number?: number;
    town?: string;
    manager?: string;
    object_id?: string;
    created?: string;
    order_id?: string;
    comment?: string;
    object_note?: string;
    company?: string;
    products?: any;
}) => {
    const formatText = (text: string | undefined, defaultChar: string = ''): string => {
        if (!text) return defaultChar; // Return a placeholder if the comment is empty
        return `${text}`
            .trim() // Remove leading and trailing spaces
            .replace(/\s+/g, ' ') // Replace multiple spaces with a single space
            .replace(/\n/g, '<br />') // Replace newlines with <br />
            .replace(/\t/g, ' '); // Replace tabs with a single space
    };

    const formatDescription = (description: string | undefined): string => {
        if (!description) return ''; // Return empty if no description
        return description
            .trim() // Remove leading and trailing spaces
            .replace(/\s+/g, ' ') // Replace multiple spaces with a single space
            .replace(/\n/g, '') // Replace newlines
            .replace(/\t/g, ' '); // Replace tabs with a single space
    };

    return (
        <div className="container">
            <div className="header">
                <div className="customer-address">
                    <strong>Lieferanschrift</strong>
                    <br />
                    {formatText(company)}
                    <br />
                    {formatText(street)} {formatText(housenumber)} <br />
                    {formatText(postalcode)} {formatText(town)}
                    <div className="project-info">
                        <strong>Objektleiter:</strong> {formatText(manager, '-')}
                        <br />
                        <strong>Objektnummer:</strong> {formatText(`${object_number}`)}
                        <br />
                        <strong>Bestelldatum:</strong> {formatText(created)}
                    </div>
                </div>

                <div className="company-info">
                    <img
                        src={`/${companyLogo}`}
                        alt="Firmenlogo"
                        className="logo"
                    />
                    <br />
                    {companyName}
                    <br />
                    {companyStreet}
                    <br />
                    {companyPostalCode} {companyTown}
                </div>
            </div>

            <div className="document-title">Lagerentnahmeschein {formatText(order_id)}-1</div>

            <div className="additional-info">
                Weitere Informationen: '{formatText(object_note)}'
            </div>

            <table>
                <thead>
                    <tr>
                        <th>Pos.</th>
                        <th>Art. Nr.</th>
                        <th>Beschreibung</th>
                        <th>Menge</th>
                    </tr>
                </thead>
                <tbody>
                    {(products || [])
                        .sort((a: any, b: any) => a.article_number - b.article_number)
                        .map((product: any, index: number) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{product.article_number}</td>
                                <td>
                                    {product.name}
                                    {showItemDescription ? (
                                        <span> - {formatDescription(product.description)}</span>
                                    ) : null}
                                </td>
                                <td>
                                    {product.units_after}{' '}
                                    {product.unit_name ? `${product.unit_name}` : ''}
                                </td>
                            </tr>
                        ))}
                    {/* Beispielzeilen */}
                </tbody>
            </table>

            <div className="additional-info">
                Kommentar aus der Bestellung: '{formatText(comment)}'
            </div>
        </div>
    );
};

export default LagerEntnahmeSchein;
